import { IAction } from '../sagas';
import { REQUEST_POSTFEATURED_SUCCESS } from '../handlers.actions';

const initPostsStore: any = () => ([]);

/** POSTS REDUCER */
export const featuredPostReducer = (state = initPostsStore(), action: IAction) => {
    switch (action.type) {

         case REQUEST_POSTFEATURED_SUCCESS:
              const item = action.payload;
              item['id'] = new Date().getMilliseconds();
              return [
                   ...state.slice(0, item),
                   item,
                   ...state.slice(item)
              ];
          

         default:
              return state;
    }
};
